// Only log performance metrics in development environment
const IS_PERFORMANCE_MONITORING_ENABLED =
  process.env.NODE_ENV === 'development';

/**
 * Measures and logs performance metrics for eligibility calculations
 *
 * @param {string} operation - Name of the operation being measured
 * @param {Function} fn - Function to execute and measure
 * @param {Object} _context - Additional context for performance logging
 * @param {number} threshold - Threshold in milliseconds for logging performance metrics
 * @returns {*} Result of the function execution
 */
const logPerformanceMetric = (operation, fn, _context = {}, threshold = 1) => {
  if (!IS_PERFORMANCE_MONITORING_ENABLED) {
    return fn();
  }

  const startTime = performance.now();
  const result = fn();
  const endTime = performance.now();
  const duration = endTime - startTime;

  // Log performance metrics if duration exceeds threshold (1ms)
  if (duration > threshold) {
    // eslint-disable-next-line no-console
    console.warn(
      `Performance: ${operation} took ${duration.toFixed(2)}ms`,
      _context,
    );
  }

  return result;
};

export default logPerformanceMetric;
